function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_17468_146340)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M1.5 9.00005L8.73167 12.6159C8.83006 12.6651 8.87925 12.6897 8.93085 12.6994C8.97655 12.7079 9.02345 12.7079 9.06915 12.6994C9.12075 12.6897 9.16994 12.6651 9.26833 12.6159L16.5 9.00005M1.5 12.75L8.73167 16.3659C8.83006 16.4151 8.87925 16.4397 8.93085 16.4494C8.97655 16.4579 9.02345 16.4579 9.06915 16.4494C9.12075 16.4397 9.16994 16.4151 9.26833 16.3659L16.5 12.75M1.5 5.25005L8.73167 1.63421C8.83006 1.58502 8.87925 1.56042 8.93085 1.55074C8.97655 1.54217 9.02345 1.54217 9.06915 1.55074C9.12075 1.56042 9.16994 1.58502 9.26833 1.63421L16.5 5.25005L9.26833 8.86588C9.16994 8.91508 9.12075 8.93967 9.06915 8.94936C9.02345 8.95793 8.97655 8.95793 8.93085 8.94936C8.87925 8.93967 8.83006 8.91508 8.73167 8.86588L1.5 5.25005Z",
  stroke: "#475467",
  strokeWidth: 1.3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_17468_146340"
}, /*#__PURE__*/React.createElement("rect", {
  width: 18,
  height: 18,
  fill: "white"
})));

function SvgSxLibrary(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSxLibrary);
export default __webpack_public_path__ + "static/media/sx-library.fe72f43b.svg";
export { ForwardRef as ReactComponent };